<div class="_calendar-mobile-page">

    <div class="_calendar-headers">

		<ion-fab vertical="bottom" horizontal="end" slot="fixed" class="_fab">
			<ion-fab-button color="warning">
			  	<ion-icon src="./assets/icons/more-options.svg"></ion-icon>
			</ion-fab-button>
			<ion-fab-list side="start">
				<ion-fab-button color="warning" (click)="controller.getDisplayCalendarEvents()">
					<ion-icon name="refresh"></ion-icon>
				</ion-fab-button>			
			</ion-fab-list>
		</ion-fab>
    </div>

	<calendar-mobile-component
		[events]="$any(controller.events)"
		[refresh]="controller.refresh"
		[viewDate]="controller.viewDate"
		[showFilters]="true"
		[showViewSelection]="true"
		[translations]="controller.translations"
		(viewDateChanged)="controller.onViewDateChanged($any($event))"
		(viewChanged)="controller.onViewChanged($any($event))"
		(eventClick)="controller.onEventClick($any($event))"
		(eventDrag)="controller.onEventDrag($any($event))"
		(dayChanged)="controller.onDayChanged($any($event))"
		(hourSegmentClick)="controller.onHourSegmentClick($any($event))"
	></calendar-mobile-component>

</div>

  